/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFoodsourceDropDownGet } from '../fn/food-source/api-foodsource-drop-down-get';
import { ApiFoodsourceDropDownGet$Params } from '../fn/food-source/api-foodsource-drop-down-get';
import { apiFoodsourceGet } from '../fn/food-source/api-foodsource-get';
import { ApiFoodsourceGet$Params } from '../fn/food-source/api-foodsource-get';
import { apiFoodsourcePost } from '../fn/food-source/api-foodsource-post';
import { ApiFoodsourcePost$Params } from '../fn/food-source/api-foodsource-post';
import { apiFoodsourcePut } from '../fn/food-source/api-foodsource-put';
import { ApiFoodsourcePut$Params } from '../fn/food-source/api-foodsource-put';
import { FoodSourceDropdown } from '../models/food-source-dropdown';
import { FoodSourceDto } from '../models/food-source-dto';
import { NotificationMessage } from '../models/notification-message';

@Injectable({ providedIn: 'root' })
export class FoodSourceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFoodsourceGet()` */
  static readonly ApiFoodsourceGetPath = '/api/foodsource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoodsourceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoodsourceGet$Response(params?: ApiFoodsourceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FoodSourceDto>>> {
    return apiFoodsourceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFoodsourceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoodsourceGet(params?: ApiFoodsourceGet$Params, context?: HttpContext): Observable<Array<FoodSourceDto>> {
    return this.apiFoodsourceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FoodSourceDto>>): Array<FoodSourceDto> => r.body)
    );
  }

  /** Path part for operation `apiFoodsourcePut()` */
  static readonly ApiFoodsourcePutPath = '/api/foodsource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoodsourcePut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFoodsourcePut$Response(params?: ApiFoodsourcePut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiFoodsourcePut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFoodsourcePut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFoodsourcePut(params?: ApiFoodsourcePut$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiFoodsourcePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiFoodsourcePost()` */
  static readonly ApiFoodsourcePostPath = '/api/foodsource';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoodsourcePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFoodsourcePost$Response(params?: ApiFoodsourcePost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
    return apiFoodsourcePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFoodsourcePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFoodsourcePost(params?: ApiFoodsourcePost$Params, context?: HttpContext): Observable<NotificationMessage> {
    return this.apiFoodsourcePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<NotificationMessage>): NotificationMessage => r.body)
    );
  }

  /** Path part for operation `apiFoodsourceDropDownGet()` */
  static readonly ApiFoodsourceDropDownGetPath = '/api/foodsource/drop-down';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFoodsourceDropDownGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoodsourceDropDownGet$Response(params?: ApiFoodsourceDropDownGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FoodSourceDropdown>>> {
    return apiFoodsourceDropDownGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFoodsourceDropDownGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiFoodsourceDropDownGet(params?: ApiFoodsourceDropDownGet$Params, context?: HttpContext): Observable<Array<FoodSourceDropdown>> {
    return this.apiFoodsourceDropDownGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FoodSourceDropdown>>): Array<FoodSourceDropdown> => r.body)
    );
  }

}
